module.exports = __webpack_public_path__ + "static/onnurhaedogITWindows-9c7d701be8c4fef92ea8035e01aaabcb.png";